import React, {Component} from 'react';
import './style.css';

const mapi_times = [
  '06:00 - 07:00',
  '07:00 - 08:00',
  '08:00 - 09:00',
  '09:00 - 10:00',
  '10:00 - 11:00',
  '11:00 - 12:00',
  '12:00 - 13:00',
  '13:00 - 14:00',
  '14:00 - 15:00'
];

const mapi_mountain_times = [
  '06:00',
  '07:00',
  '08:00'
];

// horarios rutas 2022
const c4_wayna = [
  '07:00 - 08:00',
  '08:00 - 09:00',
  '09:00 - 10:00',
  '10:00 - 11:00'
];
const c4_huchuy = [
  '07:00 - 08:00',
  '08:00 - 09:00',
  '09:00 - 10:00',
  '10:00 - 11:00',
  '11:00 - 12:00',
  '12:00 - 13:00',
];
const c3_mountain_mapi = [
  '07:00 - 08:00',
  '08:00 - 09:00',
  // '09:00 - 10:00',
  // '10:00 - 11:00'
];
const c1_c2_puente_inka = [
  '07:00 - 08:00',
  '08:00 - 09:00',
  '09:00 - 10:00',
  '10:00 - 11:00',
  '11:00 - 12:00',
  '12:00 - 13:00',
  '13:00 - 14:00',
  '14:00 - 15:00'
];

class AdmissionTime extends Component {

  constructor(props) {
    super(props);

    this.state = {
      current_time: (props.nts) ? '': '08:00 - 09:00'
    };

  }

  selectTime(stime) {
    this.props.parentCallback(stime);

    this.setState({
      current_time: stime
    });
  }

  render() {

    let times = [];

    switch (this.props.trip.id) {
      case 0:
        times = mapi_times;
        break;
      case 1:
      case 2:
        times = mapi_mountain_times;
        break;
      case 5:
        times = c4_wayna;
        break;
      case 6:
        // Montaña Machupicchu + Circuito 3
        times = c3_mountain_mapi;
        break;
      case 7:
        times = c4_huchuy;
        break;
      case 8:
        times = c1_c2_puente_inka;
        break;
      default:
        break;
    }

    return (

      <div>
        {times.map(time =>
          <div className={(this.state.current_time === time) ? 'btn-trip-time btn-t-active' : 'btn-trip-time'} key={time} onClick={()=> this.selectTime(time)} >
            <p className="subheading">{time} hrs</p>
          </div>
        )}
      </div>

    );
  }
}

export default AdmissionTime;
